module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm@2-93831091d245fb4b2e531132ce838442.png";